import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

const GET_PLACE_PREDICTIONS = gql`
  query GetPlacePredictions(
    $input: String!
    $visitorId: String!
    $regionCode: String
    $locationBias: String
    $addressBias: AddressBiasInput
  ) {
    getPlacePredictions(
      input: $input
      visitorId: $visitorId
      regionCode: $regionCode
      locationBias: $locationBias
      addressBias: $addressBias
    ) {
      placeId
      description
      mainText {
        text
        matches {
          startOffset
          endOffset
        }
      }
      secondaryText {
        text
        matches {
          startOffset
          endOffset
        }
      }
    }
  }
`;

/**
 * Apollo request
 */
const getPlacePredictionsQuery = async ({ variables }) => {
  try {
    const { data } = await query({
      query: GET_PLACE_PREDICTIONS,
      variables: {
        input: variables.input,
        visitorId: variables.visitorId,
        regionCode: variables.regionCode,
        locationBias: variables.locationBias,
        addressBias: variables.addressBias,
      },
    });

    return data.getPlacePredictions;
  } catch (error) {
    throw new Error('Failed to query place predictions', error);
  }
};

export default getPlacePredictionsQuery;
